var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecorCorner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V64C17.67 64 32 49.67 32 32C49.67 32 64 17.67 64 0H32Z",
    fill: "#EFF2FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 15.7603C15.36 15.7603 18.15 12.9703 18.15 9.51031C18.15 9.12031 18.46 8.82031 18.84 8.82031C19.22 8.82031 19.53 9.13031 19.53 9.51031C19.53 12.9703 22.32 15.7603 25.78 15.7603C26.17 15.7603 26.47 16.0703 26.47 16.4503C26.47 16.8303 26.16 17.1403 25.78 17.1403C22.32 17.1403 19.53 19.9303 19.53 23.3903C19.53 23.7803 19.22 24.0803 18.84 24.0803C18.46 24.0803 18.15 23.7703 18.15 23.3903C18.15 19.9303 15.36 17.1403 11.9 17.1403C11.51 17.1403 11.21 16.8303 11.21 16.4503C11.21 16.0703 11.52 15.7603 11.9 15.7603V15.7603Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorCorner);
export default __webpack_public_path__ + "static/media/decor-corner.cd4a0bdfec7397de92a883212deae66f.svg";
export { ForwardRef as ReactComponent };